export const GOOGLE_PKCE_VERIFIER_STORAGE_KEY = "googlePkceVerifier";

const base64UrlEncode = (arrayBuffer) => {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = "";

  for (let index = 0; index < bytes.length; index++) {
    binary += String.fromCharCode(bytes[index]);
  }

  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

export const createPkceVerifier = (byteLength = 64) => {
  const randomBytes = new Uint8Array(byteLength);
  crypto.getRandomValues(randomBytes);
  return base64UrlEncode(randomBytes);
};

export const createPkceChallenge = async (codeVerifier) => {
  const encodedVerifier = new TextEncoder().encode(codeVerifier);
  const hashedVerifier = await crypto.subtle.digest("SHA-256", encodedVerifier);
  return base64UrlEncode(hashedVerifier);
};
